import { useSearchParams } from 'react-router-dom'

import GlobalPrivacyNotices from 'pages/policies/privacy-notices/global/global-privacy-notices'
import KorPrivacyNoticesLatest from 'pages/policies/privacy-notices/kr/kor-privacy-notices-latest'
import TurPrivacyNoticesLatest from 'pages/policies/privacy-notices/tr/privacy-notices-latest'
import { convertCountryCode2to3, countryCode } from 'utils/i18n'

enum COUNTRY_TYPE {
  GLOBAL,
  KOR,
  TUR
}

export default function PrivacyNotices() {
  const [searchParam] = useSearchParams()
  const paramCountryCode = searchParam.get('countryCode')
  const effectiveCountryCode = paramCountryCode ? convertCountryCode2to3(paramCountryCode) : countryCode
  const country_type =
    effectiveCountryCode === 'KOR' ? COUNTRY_TYPE.KOR : effectiveCountryCode === 'TUR' ? COUNTRY_TYPE.TUR : COUNTRY_TYPE.GLOBAL

  return country_type === COUNTRY_TYPE.GLOBAL ? (
    <GlobalPrivacyNotices />
  ) : country_type === COUNTRY_TYPE.KOR ? (
    <KorPrivacyNoticesLatest />
  ) : (
    <TurPrivacyNoticesLatest />
  )
}
